export namespace PropertyDetailStates {
    export function propertyDetailStatesFactory() {
        const propertyDetail: any = {
            isFetching: false,
            timestamp: new Date()
        };
        return propertyDetail;
    }

    export function mutations() {
        return {
            propertyDetailStartFetching(state: any) {
                state.propertyDetail.isFetching = true;
            },
            propertyDetailEndFetching(state: any) {
                state.propertyDetail.isFetching = false;
            },
        };
    }
}
